<template>
  <img
    :src="productImage"
    @error="onError"
    width="100%"
  >
</template>
<script>
export default {
  name: 'ListImage',
  props: {
    src: {
      type: String,
      default: () => '',
    },
  },
  data () {
    return {
      defaultImage: `${this.$root.cdnUrl}/assets/default.jpg`,
      productImage: '',
    };
  },
  methods: {
    onError (im) {
      im.target.src = this.defaultImage;
    },
  },
  created () {
    this.productImage = this.src;
  },
};
</script>
